// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/main-page/main-page';
import 'sections/main-404/main-404';
import 'sections/intro-block/intro-block';
import 'sections/slim-banner/slim-banner';
import 'sections/info-panel/info-panel';
import 'sections/animated-panel/animated-panel';
import 'sections/content-panel/content-panel';
import 'sections/collapsible-content/collapsible-content';
import 'sections/faqs/faqs';
import 'sections/tabs/tabs';
import 'sections/collection-list/collection-list';
import 'sections/app-wrapper/app-wrapper';
import 'sections/content-cards/content-cards';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-hero/page-hero';
import 'sections/pdp-content-panel/pdp-content-panel';
import 'sections/rich-text/rich-text';
import 'sections/video-banner/video-block';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/anchor-links/anchor-links';
import 'sections/compare-block/compare-block';
import 'sections/main-ingredients/main-ingredients';
import 'sections/affiliate-product-driver/affiliate-product-driver';
import 'sections/three-cards-section/three-cards-section';
import 'sections/image-and-cards/image-and-cards';
import 'sections/logo-list/logo-list';
import 'sections/image-quote/image-quote-section';
import 'sections/detailed-product-landing/detailed-product-landing';
import 'sections/collage/collage';
import 'sections/featured-collections/featured-collections';
import 'sections/featured-reviews/featured-reviews';
import 'sections/product-showcase/product-showcase';